// extracted by mini-css-extract-plugin
export default {"header":"header_header__BDkG8","logout":"header_logout__gjH4h","backbutton":"header_backbutton__8ozTI"};